<div class="dark text-justify privacy-policy-page scroll-box">
  <div class="info-header">
    <h4 class="info-title">{{ 'Privacy Policy' | translate }}</h4>
  </div>
  <hr>
  <div>
    <ng-container *ngIf="mainContent && mainContent.length > 0 && !isSkeletonMainContent; else skeletonMainContent">
      <p [innerHTML]="sanitize(mainContent[0]?.description)" class="m-b-25"></p>
    </ng-container>

    <ng-template #skeletonMainContent>
      <ng-container *ngIf="isSkeletonMainContent">
        <ng-container *ngFor="let item of [].constructor(4)">
          <p class="skeleton skeleton-text mb-1"></p>
        </ng-container>
        <p class="skeleton skeleton-text mb-3 w-75"></p>
      </ng-container>
    </ng-template>

    <ng-container *ngIf="privacyPolicy && !isSkeletonMainContent; else skeletonPrivacyPolicy">
      <div class="container p-l-0 p-r-0">
        <mat-accordion class="vip-faq list-style-p">
          <ng-container *ngFor="let row of privacyPolicy">
            <ng-container *ngIf="row.content_type == 2 && row.status == 1">
              <mat-expansion-panel (opened)="panelOpenState = true" (afterExpand)="scroll(row.id)" (closed)="panelOpenState = false" hideToggle class="m-b-10">
                <mat-expansion-panel-header>
                  <mat-panel-title [id]="row.id">
                    {{ row.title }}
                    <i class="icon-chevron-down dropdown-arrow-img"></i>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <p [innerHTML]="row.description.replace('&lt;p&gt;', '').replace('&lt;/p&gt;', '')"></p>
              </mat-expansion-panel>
            </ng-container>
          </ng-container>
        </mat-accordion>
      </div>
    </ng-container>

    <ng-template #skeletonPrivacyPolicy>
      <ng-container *ngIf="isSkeletonMainContent">
        <div *ngFor="let item of [].constructor(5) | slice:0:1">
          <mat-accordion class="faq-section">
            <ng-container *ngFor="let item of [].constructor(5)">
              <mat-expansion-panel class="m-b-15 border-0 skeleton-faq-mat-header">
                <mat-expansion-panel-header class="skeleton"></mat-expansion-panel-header>
              </mat-expansion-panel>
            </ng-container>
          </mat-accordion>
        </div>
      </ng-container>
    </ng-template>
  </div>
</div>
